import React from 'react';
import { IOrderHistoryResources } from './../order-history.props.autogenerated';
import { DebouncedInput } from './debounced-input';

export default function({
    globalFilter,
    setGlobalFilter,
    resources
}: {
    globalFilter: string;
    setGlobalFilter: React.Dispatch<React.SetStateAction<string>>;
    resources: IOrderHistoryResources;
}) {
    return (
        <div className='msc-section-box'>
            <h4 className='ms-order-history__search-title msc-section-box__title'>{resources.orderHistorySearchHeading}</h4>
            <fieldset className='msc-form__group'>
                <label htmlFor='soldTosSearch' className='sr-only'>
                    {resources.orderHistorySearchLabel}
                </label>
                <DebouncedInput
                    type='search'
                    value={globalFilter ?? ''}
                    onChange={(value: string) => setGlobalFilter(String(value))}
                    placeholder={resources.orderHistorySearchPlaceholder}
                    resources={resources}
                    data-cy='order-history__search-box'
                />
            </fieldset>
        </div>
    );
}
